import AdbInputNumber from './src/adb-input-number.vue';

AdbInputNumber.install = function (Vue) {
  Vue.component(AdbInputNumber.name, AdbInputNumber);
};

export default AdbInputNumber;
